import { render, staticRenderFns } from "./customerCertificates.vue?vue&type=template&id=50366544"
import script from "./customerCertificates.vue?vue&type=script&lang=js"
export * from "./customerCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports